import { useAuth } from "react-oidc-context";

import type { ReactNode } from "react";

interface AuthGateProps {
  children: ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  const auth = useAuth();

  if (auth.isLoading) {
    return <CenteredMessage>Authenticating…</CenteredMessage>;
  }

  if (auth.error) {
    return (
      <CenteredMessage tone="crit">
        Authentication failed: {auth.error.message}
        <button
          onClick={() => auth.signinRedirect()}
          style={{ marginTop: 16, ...buttonStyle }}
        >
          Try sign-in again
        </button>
      </CenteredMessage>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <CenteredMessage>
        <h1 style={{ margin: 0, fontSize: "1.6rem" }}>Orixen Fleet</h1>
        <p style={{ color: "var(--text-dim)", margin: "12px 0 24px" }}>
          Sign in with your Orixen account.
        </p>
        <button onClick={() => auth.signinRedirect()} style={buttonStyle}>
          Sign in with Keycloak
        </button>
      </CenteredMessage>
    );
  }

  return <>{children}</>;
}

interface CenteredMessageProps {
  children: ReactNode;
  tone?: "ok" | "crit";
}

function CenteredMessage({ children, tone }: CenteredMessageProps) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: 24,
        color: tone === "crit" ? "var(--crit)" : "var(--text)",
        textAlign: "center",
      }}
    >
      {children}
    </div>
  );
}

const buttonStyle: React.CSSProperties = {
  background: "var(--accent)",
  color: "var(--bg)",
  border: "none",
  padding: "10px 18px",
  borderRadius: 6,
  fontSize: "0.95rem",
  fontWeight: 600,
  cursor: "pointer",
};
